'use client';

import CaretIcon from 'components/icons/CaretIcon';
import UIButton from 'components/buttons/UIButton';
import { ANALYTICS_EVENTS, capture } from 'lib/analytics';

type PlannerDownloadButtonProps = {
  label: string;
  href: string;
};

export default function PlannerDownloadButton({
  label,
  href,
}: PlannerDownloadButtonProps) {
  return (
    <UIButton
      buttonType="secondary"
      label={label}
      icon={<CaretIcon direction="right" size="large" />}
      href={href}
      aria-label="Pre-enrollment planner link"
      className="pre-enrollment-button"
      onClick={() => capture(ANALYTICS_EVENTS.plannerDownloaded)}
    />
  );
}
